/* Added the following code for POW-NOTIFY.Istiyak using AI Agent. April 5, 2026. Code Start */
/**
 * REST helpers for the notifications feature.
 * GET /api/notifications is unauthenticated on the backend — no Authorization header.
 */
import axios from 'axios';
import {
	NOTIFICATIONS_LIST_URL,
	NOTIFICATIONS_MARK_ONE_READ_URL,
	NOTIFICATIONS_MARK_ALL_READ_URL,
	NOTIFICATIONS_DELETE_ONE_URL,
	NOTIFICATIONS_DELETE_ALL_URL
} from 'app/constants/ApiConstants';

/* Added the following code for Istiyak using AI Agent. April 8, 2026. Code Start */
function getAuthConfig() {
	const token = localStorage.getItem('bearer_token');
	return token
		? { headers: { Authorization: `Bearer ${token}` } }
		: {};
}
/* Code end. Istiyak using AI Agent. April 8, 2026 */

/**
 * Fetches paged notifications from GET /api/notifications?username=&page=&size=.
 * Returns a normalized Spring Page-like shape for easier consumer logic.
 */
export async function fetchNotificationsList({ username, page = 0, size = 50 }) {
	const { data } = await axios.get(NOTIFICATIONS_LIST_URL, {
		params: {
			username,
			page,
			size
		}
	});

	if (data && Array.isArray(data.content)) {
		return {
			content: data.content,
			totalElements: Number(data.totalElements) || data.content.length,
			totalPages: Number(data.totalPages) || 1,
			number: Number(data.number) || 0,
			size: Number(data.size) || size
		};
	}

	const list = Array.isArray(data) ? data : (data && Array.isArray(data.notifications) ? data.notifications : []);
	return {
		content: list,
		totalElements: list.length,
		totalPages: 1,
		number: 0,
		size
	};
}
/* Added the following code for Istiyak using AI Agent. April 8, 2026. Code Start */
export async function markNotificationRead({ notificationsId, username }) {
	const authConfig = getAuthConfig();
	await axios.put(
		NOTIFICATIONS_MARK_ONE_READ_URL.replace('{notificationsId}', String(notificationsId)),
		null,
		{
			...authConfig,
			params: { username }
		}
	);
}

export async function markAllNotificationsRead({ username }) {
	const authConfig = getAuthConfig();
	await axios.put(NOTIFICATIONS_MARK_ALL_READ_URL, null, {
		...authConfig,
		params: { username }
	});
}

export async function deleteNotificationById({ notificationsId, username }) {
	const authConfig = getAuthConfig();
	await axios.delete(NOTIFICATIONS_DELETE_ONE_URL.replace('{notificationsId}', String(notificationsId)), {
		...authConfig,
		params: { username }
	});
}

export async function deleteAllNotifications({ username }) {
	const authConfig = getAuthConfig();
	await axios.delete(NOTIFICATIONS_DELETE_ALL_URL, {
		...authConfig,
		params: { username }
	});
}
/* Code end. Istiyak using AI Agent. April 8, 2026 */
/* Code end. Istiyak using AI Agent. April 5, 2026 */
